import { ReactNode, useState } from 'react'
import cn from 'classnames/bind'

import { Header2, PageTemplateContent } from 'app/common/templates-next/page-template'
import Sticky from 'app/common/templates-next/sticky'

import ReportSectionFullscreen, { FullscreenDefaultButton } from './report-section-fullscreen'
import ReportHeaderBarItems from './report-header-bar-items'
import styles from './report-section.module.scss'

const cx = cn.bind(styles)

type Props = {
  children: ReactNode
  header?: string
  headerBar?: ReactNode
  headerContentReplaceBy?: ReactNode
  headerContentClassName?: string
  skipPadding?: boolean
  fullscreenEnabled?: boolean
  footerBar?: ReactNode
  skipFooterPadding?: boolean
  resetStickyShift?: boolean
}

const ReportSection = ({
  children,
  header,
  headerBar,
  headerContentReplaceBy,
  headerContentClassName,
  skipPadding,
  fullscreenEnabled,
  footerBar,
  skipFooterPadding,
  resetStickyShift = true,
}: Props) => {
  const [fullscreen, setFullscreen] = useState(false)

  return (
    // Нельзя убирать ReportSectionFullscreen, иначе children ведет себя непредсказуемо
    <ReportSectionFullscreen fullscreen={fullscreenEnabled ? fullscreen : false}>
      {(header || headerBar || headerContentReplaceBy) && (
        <Sticky resetShift={resetStickyShift}>
          {(ref, _, shadow) => (
            <PageTemplateContent
              borderBottom={false}
              shadowBottom={shadow}
              reference={ref}
              className={cx(styles.header, headerContentClassName)}
            >
              {headerContentReplaceBy}
              {!headerContentReplaceBy && (
                <>
                  <Header2 className={styles.headerMain}>{header}</Header2>
                  <div className={styles.space} />
                  {headerBar}
                  {fullscreenEnabled && (
                    <ReportHeaderBarItems>
                      <FullscreenDefaultButton
                        className={styles.iconFullscreen}
                        toggleFullscreenState={setFullscreen}
                      />
                    </ReportHeaderBarItems>
                  )}
                </>
              )}
            </PageTemplateContent>
          )}
        </Sticky>
      )}

      <PageTemplateContent skipPadding={skipPadding} className={cx({ content: !skipPadding })}>
        {children}
      </PageTemplateContent>

      {footerBar && (
        <Sticky stickyBottom>
          {(ref, stuck, shadow) => (
            <PageTemplateContent
              borderBottom={!stuck}
              shadowTop={shadow}
              reference={ref}
              skipPadding={skipFooterPadding}
            >
              {footerBar}
            </PageTemplateContent>
          )}
        </Sticky>
      )}
    </ReportSectionFullscreen>
  )
}

export default ReportSection
